import React, { useState, useEffect } from 'react'
import '../styles.less'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import TotalBudgetWidgets from '../../../widgets/projectProposal/budget/TotalBudgetWidgets'
import ManagementFeeWidget from '../../../widgets/projectProposal/budget/ManagementFeeWidget'
import ContributionBudgetWidgets from '../../../widgets/projectProposal/budget/ContributionBudget/ContributionBudgetWidgets'
import ActivityBudgetWidgets from '../../../widgets/projectProposal/budget/ActivityBudgetWidgets'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getBudget, getSummary, getProjectBudget } from '../../../redux/actions/budget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import pathname from '../../../constants/pathname'
import ActivityWidgets from '../../../widgets/projectProposal/budget/ActivityWidgets'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'

export default function ActivityBudget({
  schemaData,
  disabled,
  hideActivity,
  hideOther,
  projectVersionId,
}) {
  const [isEditWidget, setIsEditWidget] = useState({})
  // const [isEditAll, setIsEditAll] = useState(false)
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [summaryBudget, setSummaryBudget] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = projectVersionId || sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.projectManagementStructure}`,
    pathNameForward: `${pathname.proposal.objectiveGoal}`,
  }

  useEffect(() => {
    if (schemaData?.forms?.activity) {
      schemaData.forms.activity.disabled = disabled
    }

    schemaData?.forms?.managementFee?.map((item, index) => {
      item.form.disabled = disabled
    })

    if (schemaData?.forms?.other) {
      schemaData.forms.other.disabled = disabled
    }

    setSummaryBudget(schemaData?.forms?.summary)
    setSchema(schemaData)
    doCalculateEditWidget(schemaData)
  }, [schemaData])

  const handleGetSummary = async () => {
    try {
      console.log('handleGetSummary')
      const _schema = await getSummary(projectId)

      setSummaryBudget(_schema)
    } catch (e) {}
  }

  const handleGetActivity = async () => {
    console.log('handleGetActivity')
    handleSaveSucceed(true)
  }

  const doCalculateEditWidget = (_schema) => {
    let editObj = {
      activity: !disabled,
      other: !disabled,
    }

    let managementFee = true

    _schema?.forms?.managementFee?.forEach((item, index) => {
      if (item.form.headerOnly) {
        item.subForms.forEach((subSchema, subIndex) => {
          editObj[`subForms_${subIndex}`] = disabled
          editObj[`activity_${subIndex}`] = disabled
          // let activity = schema?.forms?.activity && !schema.forms.activity.disabled
          // managementFee = managementFee && !subSchema.disabled
        })
      } else {
        editObj[`managementFeeWidget_${index}`] = disabled
        // managementFee = managementFee && !item.form.disabled
      }
      managementFee = managementFee && !disabled
    })

    console.log('editObj : ', editObj)

    setIsEditWidget(editObj)
  }

  const handleSaveSucceed = async (bool) => {
    console.log('handleSaveSucceed ', bool)
    if (bool) {
      startLoading()
      try {
        const _schema = await getProjectBudget(projectId)
        console.log('_schema ', _schema)
        if (_schema?.forms?.activity) {
          _schema.forms.activity.disabled = disabled
        }

        _schema?.forms?.managementFee?.map((item, index) => {
          item.form.disabled = disabled
        })

        if (_schema?.forms?.other) {
          _schema.forms.other.disabled = disabled
        }

        setSchema(_schema)
        setSummaryBudget(_schema?.forms?.summary)
        doCalculateEditWidget(_schema)
      } catch (e) {
        console.log('error', e)
        if (e?.response?.data) {
          setError({
            statusCode: e.response.data.status,
            errorMessage: e.response.data.errors?.message,
          })
        } else {
          setError({})
        }
      }
      doneLoading()
    }
  }

  if (error) {
    return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <>
      {schema?.forms?.activity && !hideActivity && (
        <>
          <ActivityWidgets
            showCommandButton={!disabled}
            isEdit={isEditWidget.activity}
            schema={schema.forms.activity}
            activityBudgetValue={schema?.forms?.managementFee[0]?.subForms[0]?.values || []}
            saveSucceed={handleSaveSucceed}
            categoryType={1}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit(`activity`, _isEdit, setIsEditWidget)}
            shaded={false}
            projectVersionId={projectVersionId}
          />
          <br />
        </>
      )}

      {schema?.forms?.managementFee && (
        <>
          <ManagementFeeWidget
            // showCommandButton={!schema.forms.managementFee.disabled}
            schema={schema.forms.managementFee}
            activityValue={schema?.forms?.activity?.value}
            // isEdit={isEditWidget.other}
            getSummary={handleGetSummary}
            getActivity={handleGetActivity}
            handleOnChangeIsEdit={handleOnChangeIsEdit}
            setIsEditWidget={setIsEditWidget}
            isEditWidget={isEditWidget}
            // onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('other', _isEdit, setIsEditWidget)}
            shaded={false}
            projectVersionId={projectVersionId}
          />
        </>
      )}

      {summaryBudget && (
        <>
          <TotalBudgetWidgets schema={summaryBudget} shaded={false} />
          <br />
        </>
      )}

      {schema?.forms?.other && !hideOther && (
        <>
          <ContributionBudgetWidgets
            showCommandButton={!schema.forms.other.disabled}
            isEdit={isEditWidget.other}
            schema={schema.forms.other}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('other', _isEdit, setIsEditWidget)}
            shaded={false}
          />
          <br />
        </>
      )}
    </>
  )
}
